import { useState } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import CustomInput from "../CustomInput";
import CustomSelectSimple from "../CustomSelectSimple";

const tipoviAll = ["POSLOVNA JEDINICA", "GRADILISTE", "RADILISTE"];

const style = {
  btn: {
    padding: "7px",
    fontWeight: "bold",
    minHeight: "64px",
    fontSize: "16px"
  }
};

const emptyItem = {
  naziv: "",
  tip: ""
};

const mapTipovi = {
  "POSLOVNA JEDINICA": "POSLOVNE_JEDINICE",
  GRADILISTE: "GRADILISTA",
  RADILISTE: "RADILISTA"
};

function Dodavanje({ setData, setIsDodaj }) {
  const [newItem, setNewItem] = useState(emptyItem);

  const { dictionary } = useGlobalContext();

  const handleChange = (field, value) => {
    setNewItem((prev) => ({ ...prev, [field]: value }));
  };

  const handleSacuvaj = () => {
    const tipData = mapTipovi[newItem.tip];
    setData((prev) => ({
      ...prev,
      [tipData]: [
        ...(prev[tipData] || []),
        { ...newItem, id: String(Math.random()) } // id from backend
      ]
    }));
    setIsDodaj(false);
  };

  const isDisabledSacuvaj = !newItem.naziv || !newItem.tip;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <CustomInput
        value={newItem.naziv}
        onChange={(newValue) => handleChange("naziv", newValue)}
        label={dictionary["naziv"]}
      />
      <CustomSelectSimple
        label={dictionary["tip"]}
        allValues={tipoviAll}
        selectedValue={newItem.tip}
        onSelectChange={(newValue) => handleChange("tip", newValue)}
      />

      <div style={{ display: "flex", gap: "5px" }}>
        <div onClick={() => setIsDodaj(false)} style={{ width: "35%" }}>
          <Button style={style.btn}>{dictionary["nazad"]}</Button>
        </div>
        <div
          onClick={handleSacuvaj}
          style={{ width: "65%", opacity: isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <Button isDisabled={isDisabledSacuvaj} style={style.btn}>
            {dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Dodavanje;
